import axiosApi from "../../ApiConfig";

export const ApiPut = async (path, body) => {
  return axiosApi.put(path, body);
};

export const ApiPost = async (path, body) => {
  return axiosApi.post(path, body);
};
